import { createJSONStorage, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

import {
  USER_STATUS_TYPES,
  checkAdminUserStatus,
} from "../utils/helpers/admin.helper";

const ingestData = (responseData) => {
  if (!responseData) return [];
  return responseData["Users"].map((listData) => {
    const userAttributes = {};
    listData["Attributes"].forEach((obj) => {
      userAttributes[obj["Name"]] = obj["Value"];
    });
    const status = checkAdminUserStatus(
      listData["Enabled"],
      listData["UserStatus"]
    );
    return {
      firstName: userAttributes["given_name"],
      lastName: userAttributes["family_name"],
      email: userAttributes["email"],
      createdBy: userAttributes["custom:created_by"],
      statusText: status,
      statusType: USER_STATUS_TYPES[status],
      actions: [
        { action: "disableUser", email: userAttributes["email"] },
        { action: "logoutUser", email: userAttributes["email"] },
      ],
    };
  });
};

const useStore = createWithEqualityFn(
  persist(
    (set, get) => ({
      data: {
        list: [],
      },
      actions: {
        saveUsers: (response) => {
          const ingestedData = ingestData(response);
          set({
            data: {
              list: ingestedData,
            },
          });
          return ingestedData;
        },
      },
    }),
    {
      name: "api-admin-users",
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used,
      partialize: ({ data }) => ({ data }),
    }
  )
);

export default useStore;
